function ApiKeyModal({ isOpen, onClose, apiKey, setApiKey, onSave, isLoadingHeygenKey }) {
    try {
        if (!isOpen) return null;

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-name="api-key-modal">
                <div className="bg-white rounded-xl w-full max-w-md shadow-2xl" data-name="modal-content">
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-bold">HeyGen API Key 設定</h2>
                            <button 
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600"
                                data-name="close-button"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        
                        <p className="mb-4 text-gray-600">
                            要使用數字人功能，您需要提供 HeyGen API Key。您可以在 HeyGen 開發者設定頁面獲取 API Key。
                        </p>
                        
                        <div className="mb-4">
                            <label htmlFor="apiKey" className="block text-sm font-medium text-gray-700 mb-2">
                                HeyGen API Key
                            </label>
                            <input
                                type="password"
                                id="apiKey"
                                value={apiKey}
                                onChange={(e) => setApiKey(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
                                placeholder="輸入您的 HeyGen API Key"
                                data-name="api-key-input"
                            />
                        </div>
                        
                        <div className="flex justify-end space-x-3">
                            { !isLoadingHeygenKey && <button
                                onClick={onClose}
                                className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                                data-name="cancel-button"
                            >
                                取消
                            </button> }
                            <button
                                onClick={() => onSave(apiKey)}
                                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                disabled={!apiKey || isLoadingHeygenKey}
                                data-name="save-button"
                            >
                                { isLoadingHeygenKey ? 'Loading...' : '儲存 API Key' }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        console.error('ApiKeyModal component error:', error);
        reportError(error);
        return null;
    }
}

export default ApiKeyModal;